import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'top_match_card';

export const useTopMatchCardPointTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Наибольшее совпадение',
    attributes: 'Атрибуты',
    additional_properties: 'Дополнительные свойства',
    no_data: 'Нет данных',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Top match',
    attributes: 'Attributes',
    additional_properties: 'Additional properties',
    no_data: 'No data',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Mejor coincidencia',
    attributes: 'Atributos',
    additional_properties: 'Propiedades adicionales',
    no_data: 'Sin datos',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Principal correspondência',
    attributes: 'Atributos',
    additional_properties: 'Propriedades adicionais',
    no_data: 'Sem dados',
  },
}) : {}) as Record<string, unknown>;
